import React from 'react';
import style from './style.module.scss';

const PadLock = () => (
  <div className={style.padlock}>
    <i className="fas fa-lock" />
  </div>
);

export default PadLock;
